module.exports = __webpack_public_path__ + "img/icon_map_38_off_111.e4997bef.png";